module.exports = __webpack_public_path__ + "static/img/HList7.bcdbead3.png";